import Vue from 'vue';
import Vuex from 'vuex';

// modules
import blog from '@/store/modules/blog';
import contactUs from '@/store/modules/contactUs';
import vacancies from '@/store/modules/vacancies';
import applyForm from '@/store/modules/applyForm';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    blog,
    contactUs,
    vacancies,
    applyForm,
  },
});
